import React, { useState } from "react";
import { Badge, Button, Modal, Toast } from "../../../../../../../Components";
import { useNavigate } from "react-router-dom";
import FlightItinerary from "../../Round/Result/Components/itinerary";
import { apis, post } from "../../../../../../../Utils/axios";
import { formatedPrice } from "Utils/utils";
import { useUserPolicy } from "../../../../../../../Hooks/useUserPolicy";
import moment from "moment";

function Payment({ fareConfirmDetails, flight, passengers, customFields = {}, amount, approvalId, requestId, costCenterId }) {
	const NAVIGATE = useNavigate();
	const [Loading, setLoading] = useState(false);
	const { travelPolicy } = useUserPolicy();
	const { enabled } = travelPolicy?.payment || { enabled: true }; //Enabled by default
	const [PriceCheckData, setPriceCheckData] = useState(null);

	const { segments, returnSegments } = flight;

	const fareRecheck = () => {
		setLoading(true);
		post(
			apis.recheckFlightFare,
			{
				selectedFlightOptionKey: fareConfirmDetails?.selectedFlightOptionKey,
				travellers: passengers.map(({ id, isGuest }) => (isGuest ? { guestId: id } : { userId: id })),
				approvalId,
				requestId,
				from: segments[0].departureCode,
				to: segments[0].arrivalCode,
				date: moment.utc(segments[0].departureTime).format("DD-MM-YYYY"),
			},
			(r, e) => {
				if (r) {
					setLoading();
					setPriceCheckData(r);
					//Proceed when no errors
					if (!r.error_code && r.priceDiffernce === 0) {
						startBooking("WALLET", r);
					}
				} else if (e) {
					setLoading();
					Toast.handleError(e);
				}
			}
		);
	};

	const startBooking = (paymentMode, priceCheckData) => {
		const { logo, airlineName, airlineCode, flightNumber } = flight?.segments[0] || {};
		NAVIGATE(`/app/travel/flights/confirm`, {
			state: {
				priceCheckData,
				selectedFlightOptionKey: priceCheckData.selectedFlightOptionKey,
				logo,
				name: airlineName,
				code: `${airlineCode}-${flightNumber}`,
				approvalId,
				requestId,
				customFields,
				costCenterId,
				passengers: passengers.map(({ id, isGuest }) => (isGuest ? { guestId: id } : { userId: id })),
				paymentMode,
				date: moment.utc(segments[0].departureTime).format("DD-MM-YYYY"),
				from: segments[0].departureCode,
				to: flight.segments[flight.segments.length - 1]?.arrivalCode,
				airline: airlineCode,
				flightNumber: flightNumber,
				flightType: flight.returnSegments?.length > 1 ? "roundtrip" : "oneway",
			},
		});
	};

	if (PriceCheckData?.priceDiffernce > 0.1) {
		return (
			<Modal open={true}>
				<div className="p-6 text-center border rounded-md">
					<img src={`https://cdn.travelwings.com/assets/corp/images/emojis/${PriceCheckData.priceDiffernce > 0 ? "thinking" : "smile"}.png`} alt="Eyes Emoji" className="w-24 m-auto mb-6" />
					<h1>Fare changed by Airline</h1>
					<div className="mt-2 text-sm">The fare for your booking has been changed to {formatedPrice(PriceCheckData.priceDiffernce.toFixed(2))}. You can either continue with the new price or try searching again.</div>
					<div className="gap-2 pt-6 flex-center">
						<Button loading={Loading} onClick={() => startBooking("WALLET", PriceCheckData)} variant="primary" className="btn-sm">
							Continue with new Price
						</Button>
						<Button onClick={() => NAVIGATE(-1)} variant="dark" className="btn-sm">
							Go Back to Search
						</Button>
					</div>
				</div>
			</Modal>
		);
	}

	return (
		<>
			<div className="p-4 border rounded-md">
				<FlightItinerary onwardSegments={segments} returnSegments={returnSegments} />
				<div className="mt-8">
					<h2>
						Your total amount is {flight?.selectedFare?.currency} {formatedPrice(amount?.toFixed(2))}
					</h2>
					<div className="mt-2 text-label">You can pay using Debit Card or Credit Card through end-to-end secure payment gateway</div>
				</div>
				{enabled ? (
					<div className="flex gap-2 mt-8">
						<Button loading={Loading} onClick={fareRecheck} variant="primary">
							Book Flight
						</Button>
					</div>
				) : (
					<Badge variant="danger mt-8">Payments are disabled for your account</Badge>
				)}
			</div>
		</>
	);
}

export default Payment;
